import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, "Es wurde kein Grund angegeben", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = { class: "media-list" }
const _hoisted_9 = { class: "media" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-none d-lg-block" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-danger text-danger rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-info3" })
  ])
], -1)
const _hoisted_11 = { class: "media-body align-self-center" }
const _hoisted_12 = {
  class: "media-heading font-weight-bold font-italic",
  id: "alarm_reason"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold mb-4 mt-5" }, "Videos", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "col-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, "Keine Videos vorhanden", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-img-actions mx-1 mt-1" }
const _hoisted_20 = { class: "card-img embed-responsive embed-responsive-16by9" }
const _hoisted_21 = {
  width: "320",
  height: "240",
  controls: ""
}
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("source", {
  src: "movie.ogg",
  type: "video/ogg"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-start flex-nowrap" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "font-weight-semibold mr-2" }, "Video")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "list-icons list-icons-extended ml-auto" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.reason)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.reason), 1)
                ])
              ])
            ])
          ]))
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      (_ctx.videos.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-12 col-sm-6 col-md-4"
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("video", _hoisted_21, [
                  _createElementVNode("source", {
                    src: video,
                    type: "video/mp4"
                  }, null, 8, _hoisted_22),
                  _hoisted_23,
                  _hoisted_24
                ])
              ])
            ]),
            _hoisted_25
          ])
        ]))
      }), 128))
    ])
  ]))
}